module.exports = __webpack_public_path__ + "assets/a7fd7a9bde23b37b502a3b9bf405f519.mp3";